import { EuiSwitch } from "@inscopix/ideas-eui";
import { withUserPermission } from "hocs/withUserPermission";
import { withUserPermissionBase } from "hocs/withUserPermissionBase";

/**
 * Enhanced {@link EuiSwitch} that is disabled when the user lacks a
 * required permission.
 *
 * Context independent.
 */
export const SwitchPermissionedBase = withUserPermissionBase(EuiSwitch);

/**
 * Enhanced {@link EuiSwitch} that is disabled when the user lacks a
 * required permission.
 *
 * Reads permissions from project permissions context.
 */
export const SwitchPermissioned = withUserPermission(SwitchPermissionedBase);
